import React, { useEffect, useState } from "react";
import { HeroProductsStatic } from '../../components';
import { Banner, BannerTech } from '../../components';
import { Loader } from '../../components';
import { NumbersWrap } from '../../components';
import { NumbersRowSingle } from '../../components';
import { NumberCell } from '../../components';
import { VideoScrollAlone } from '../../components';
import { GalleryProds } from '../../components';
import { GridVirtualShowroom, HomeColumns,HeroVirtualShowroom } from '../../components';
import { useSelector } from "react-redux";
import { BaseUrl } from "../../config";

const ProductsVirtualShowroomContainer = (props) => {

  const [imgsGallery, setImgsGallery] = useState([])
  const loader = useSelector((state) => state.loader);

  const imgHero = require('../../assets/hero-solutions/hero-virtual-showroom.jpg');
  const imgposterVideo = require('../../assets/video/video-test-poster.jpg')

  const arrayLoad = [
    imgHero,
    imgposterVideo
  ]

  useEffect(() => {
    document.title = "Virtual Showroom by Invrsion"
   
    fetch(`${BaseUrl}/page?key=invrsion&slug=virtual-showroom`, {
      method: 'GET'
    })
    .then(response => {
      return response.json()
      
    }).then((res) => {
      setImgsGallery(res.data.sliderSketchfab);
    })
    
    
  }, []);
  
  const columnsEntries = [
    {
      title: 'Customisable',
      text: 'Showcase your product catalogue in a new, engaging way allowing your customers to fully customise the items they are watching.'
    },
    {
      title: 'Cost Effective',
      text: 'Boost and sustain your business growth with no need for renting bigger spaces. Showcase your full catalog engage your customers and sell your products through immersive experiences.'
    },
    {
      title: 'Limitless',
      text: 'Allow your creativity to overcome any barrier. Let your shoppers experience your products wheneveryou want, however you want. All through a VR headset.'
    },

  ]
  return (
    <React.Fragment>
      <HeroVirtualShowroom></HeroVirtualShowroom>
      <GridVirtualShowroom />
       <HomeColumns entries={columnsEntries} separators={false} />
      <div className="side--quote-wrap">
        <h6 className="md--title side--title">Feel the difference</h6>
        <p className="preset-9 side--text">We use advanced and patented technology to give your 3D objects the truest-to-life look and feel in the environment of your design. The final result is a brand new shopping experience that goes beyond the limits of physical space</p>
      </div>
      <NumbersWrap>
        <NumbersRowSingle
          extraMargin={true}
        >
          <NumberCell 
            isImage={false} 
            bigNumber="184" 
            size="B" 
            title="Dollar boost" 
            text="to global GDP from the use of VR and AR in the retail and consumer sector by 2030 (PwC)"
          />
          <NumberCell 
            isImage={false} 
            bigNumber="93" 
            size="%" 
            title="Of executives" 
            text="say they or their clients plan to increase their investment in VR and AR in the wake of COVID-19 (IDC)"
          />
        </NumbersRowSingle>
      </NumbersWrap>
      {
        imgsGallery.length > 0 &&
        <GalleryProds imgs={imgsGallery}/>
      }
      {
        !loader.isLoading &&
        <VideoScrollAlone
          idScroll="video-showroom"
          video={require('../../assets/video/video-case-virtual-showroom.mp4')} 
        />
      }
      <Banner  text="Intrigued? Let’s have a chat." route="/book-a-demo" copyRoute="Book a demo" />
      <Loader arrayLoad={arrayLoad}/>
    </React.Fragment>
  );
};

export default ProductsVirtualShowroomContainer;
